import type { MineralsRepository } from '../domain/repositories/MineralsRepository.interface';
import { Mineral, type MineralCategory } from '../domain/entities/Mineral.entity';
import { mineralsContent } from '../content/minerals.content';

export class StaticMineralsSource implements MineralsRepository {
  public async getAll(): Promise<Mineral[]> {
    return mineralsContent.map((input) => Mineral.create(input));
  }

  public async getBySlug(slug: string): Promise<Mineral | null> {
    const match = mineralsContent.find((input) => input.slug === slug);
    return match ? Mineral.create(match) : null;
  }

  public async getByCategory(category: MineralCategory): Promise<Mineral[]> {
    return mineralsContent
      .filter((input) => input.category === category)
      .map((input) => Mineral.create(input));
  }
}
